import { ELanguage } from '../../Utils/constants'

const SUCCESS_CODE = 200
const API_GET_JOB_INVITATION_NOTIFICATION = 'api-gateway/v1.0/profile/job-invitation/notification'

export type TJobInvitationParams = {
    msBaseUrl: string
    langCode: ELanguage
    accessToken: string
    notifyId?: number
    jobInvitationId?: number
}

export type TInvitationNotificationItem = {
    id: number
    jobId: number
    message: string
    status: number
    time: number
    timeAgo: string
    title: string
    companyLogo: string
    companyName: string
    alias: string
    jobTitle: string
    content: string
}

export const getJobInvitationNotifications = async (
    params: TJobInvitationParams
): Promise<TInvitationNotificationItem[] | null> => {
    try {
        const { msBaseUrl, langCode, accessToken = '' } = params
        if (accessToken === '') {
            return null
        }
        const url = `${msBaseUrl}/${API_GET_JOB_INVITATION_NOTIFICATION}?limit=10`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept-Language': langCode,
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        })
        if (!response) {
            return null
        }
        const responseData = await response.json()
        if (responseData.status === SUCCESS_CODE) {
            return responseData.data
        }
        return null
    } catch (ex) {
        console.error(ex)
        return null
    }
}

export const updateReadJobInvitationNotification = async (params: TJobInvitationParams) => {
    try {
        const { msBaseUrl, langCode, accessToken = '', jobInvitationId } = params
        if (accessToken === '') {
            return null
        }
        const response = await fetch(`${msBaseUrl}/${API_GET_JOB_INVITATION_NOTIFICATION}`, {
            method: 'PUT',
            headers: {
                'Accept-Language': langCode,
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                jobInvitationId: jobInvitationId
            })
        })
        if (!response) {
            return null
        }
        return await response.json()
    } catch (ex) {
        console.error(ex)
    }
}
